import { render, staticRenderFns } from "./PositionList2022.vue?vue&type=template&id=3c76b858&scoped=true"
import script from "./PositionList2022.vue?vue&type=script&lang=js"
export * from "./PositionList2022.vue?vue&type=script&lang=js"
import style0 from "./PositionList2022.vue?vue&type=style&index=0&id=3c76b858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c76b858",
  null
  
)

export default component.exports